/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Fridge_DaysInputs */

const en_editor_fridge_days = /** @type {(inputs: Editor_Fridge_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keeps in the fridge (days)`)
};

const de_editor_fridge_days = /** @type {(inputs: Editor_Fridge_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hält im Kühlschrank (Tage)`)
};

/**
* | output |
* | --- |
* | "Keeps in the fridge (days)" |
*
* @param {Editor_Fridge_DaysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_fridge_days = /** @type {((inputs?: Editor_Fridge_DaysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Fridge_DaysInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_fridge_days(inputs)
	return en_editor_fridge_days(inputs)
});